(function() {
    'use strict';

    angular.module('app.layout', []);
})();
